import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"

export const FacetName = styled(Typography)`
    margin: 0.5rem 0 0;
`
export const FacetList = styled("span")`
    text-overflow: ellipsis;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    display: block;
    font-size: 0.875rem;
    letter-spacing: 0.008rem;
    line-height: 1.5;
`
